import { Home, Users, User, Landmark, FingerprintPattern } from "lucide-react";

export const navItems = [
  { name: "Home", path: "/home", icon: Home },
  { name: "Parties", path: "/parties", icon: Landmark },
  { name: "Candidates", path: "/candidates", icon: Users },
  { name: "eVote", path: "/e-vote", icon: FingerprintPattern },
  { name: "Profile", path: "/profile", icon: User },
];